import SiteClient from "@/clients/duallo/SiteClient";

class SiteService {

    async getSitesByOrganizationId(organizationId) {
        return await SiteClient.getSitesByOrganizationId(organizationId);
    }

    async getSite(organizationId, id) {
        return await SiteClient.getSite(organizationId, id);
    }

    async createSite(request) {
        return await SiteClient.createSite(request);
    }

    async updateSite(organizationId, id, request) {
        return await SiteClient.updateSite(organizationId, id, request);
    }

    async deleteSite(organizationId, id, softDelete = true) {
        return await SiteClient.deleteSite(organizationId, id, softDelete);
    }
}

export default new SiteService();
